/* Calinuage, thème maison. Un module par comportement ; aucune dépendance. */
(function () {
  'use strict';
  var Cl = window.Calinuage = window.Calinuage || {};

  Cl.une = function (sel, racine) { return (racine || document).querySelector(sel); };
  Cl.toutes = function (sel, racine) { return Array.prototype.slice.call((racine || document).querySelectorAll(sel)); };

  /* Navigation : méga-menu, tiroir mobile, panneau de recherche, accordéons du pied. */
  Cl.nav = {
    init: function () {
      var megas = Cl.toutes('[data-cl="mega"]'),
          tiroir = Cl.une('[data-cl="tiroir"]'), voile = Cl.une('[data-cl="voile"]'),
          burger = Cl.une('[data-cl="burger"]'), recherche = Cl.une('[data-cl="recherche"]'),
          loupe = Cl.une('[data-cl="loupe"]'), entete = Cl.une('[data-cl="entete"]');

      /* Ouvre le méga-menu d'id donné et ferme les autres ; id vide = tout fermer. */
      function megaOuvert(id) {
        megas.forEach(function (m) { m.classList.toggle('on', m.id === id); });
        Cl.toutes('[data-cl="chevron"]').forEach(function (c) {
          c.setAttribute('aria-expanded', c.getAttribute('aria-controls') === id ? 'true' : 'false');
        });
        if (id) rechercheOuverte(false);
      }
      function rechercheOuverte(oui) {
        if (!recherche) return;
        recherche.classList.toggle('on', oui);
        if (loupe) loupe.setAttribute('aria-expanded', oui ? 'true' : 'false');
        if (oui) {
          megaOuvert('');
          var champ = Cl.une('input[name="q"]', recherche);
          if (champ) champ.focus();
        }
      }
      function tiroirOuvert(oui) {
        if (!tiroir) return;
        tiroir.classList.toggle('on', oui);
        if (voile) voile.classList.toggle('on', oui);
        document.body.classList.toggle('cl-fige', oui);
        if (burger) burger.setAttribute('aria-expanded', oui ? 'true' : 'false');
        if (oui) {
          megaOuvert(''); rechercheOuverte(false);
          var fermer = Cl.une('[data-cl="fermer"]', tiroir);
          if (fermer) fermer.focus();
        } else if (burger) {
          burger.focus();
        }
      }

      Cl.toutes('[data-cl="chevron"]').forEach(function (c) {
        c.addEventListener('click', function () {
          var id = c.getAttribute('aria-controls');
          var m = document.getElementById(id);
          megaOuvert(m && m.classList.contains('on') ? '' : id);
        });
      });
      if (window.matchMedia('(hover: hover)').matches) {
        Cl.toutes('[data-cl="lien-mega"]').forEach(function (l) {
          l.addEventListener('mouseenter', function () { megaOuvert(l.dataset.mega); });
        });
        if (entete) entete.addEventListener('mouseleave', function () { megaOuvert(''); });
      }
      if (loupe) loupe.addEventListener('click', function () { rechercheOuverte(!recherche.classList.contains('on')); });
      if (burger) burger.addEventListener('click', function () { tiroirOuvert(true); });
      if (voile) voile.addEventListener('click', function () { tiroirOuvert(false); });
      if (tiroir) {
        var fermer = Cl.une('[data-cl="fermer"]', tiroir);
        if (fermer) fermer.addEventListener('click', function () { tiroirOuvert(false); });
        tiroir.addEventListener('keydown', function (e) {
          if (e.key !== 'Tab') return;
          var f = Cl.toutes('a[href], button:not([disabled])', tiroir).filter(function (el) { return el.offsetParent !== null; });
          if (!f.length) return;
          var premier = f[0], dernier = f[f.length - 1];
          if (e.shiftKey && document.activeElement === premier) { e.preventDefault(); dernier.focus(); }
          else if (!e.shiftKey && document.activeElement === dernier) { e.preventDefault(); premier.focus(); }
        });
      }
      Cl.toutes('[data-cl="sous"]').forEach(function (b) {
        b.addEventListener('click', function () {
          var liste = document.getElementById(b.getAttribute('aria-controls'));
          var oui = !liste.classList.contains('on');
          liste.classList.toggle('on', oui);
          b.setAttribute('aria-expanded', oui ? 'true' : 'false');
          var signe = Cl.une('[data-cl="signe"]', b);
          if (signe) signe.textContent = oui ? '−' : '+';
        });
      });
      Cl.toutes('[data-cl="pied"]').forEach(function (b) {
        b.addEventListener('click', function () {
          var corps = document.getElementById(b.getAttribute('aria-controls'));
          var oui = !corps.classList.contains('on');
          corps.classList.toggle('on', oui);
          b.setAttribute('aria-expanded', oui ? 'true' : 'false');
          var signe = Cl.une('[data-cl="signe"]', b);
          if (signe) signe.textContent = oui ? '−' : '+';
        });
      });
      document.addEventListener('keydown', function (e) {
        if (e.key !== 'Escape') return;
        if (tiroir && tiroir.classList.contains('on')) tiroirOuvert(false);
        megaOuvert(''); rechercheOuverte(false);
      });
    }
  };

  /* Feuille du bas mobile « Filtrer et trier » et fermeture du menu de tri. */
  Cl.filtres = {
    init: function () {
      var feuille = Cl.une('[data-cl="feuille"]'), voile = Cl.une('[data-cl="feuille-voile"]'),
          ouvrir = Cl.une('[data-cl="feuille-ouvrir"]');
      function ouverte(oui) {
        if (!feuille) return;
        feuille.classList.toggle('on', oui);
        if (voile) voile.classList.toggle('on', oui);
        document.body.classList.toggle('cl-fige', oui);
        if (ouvrir) {
          ouvrir.setAttribute('aria-expanded', oui ? 'true' : 'false');
          if (!oui) ouvrir.focus();
        }
        if (oui) { var f = Cl.une('[data-cl="feuille-fermer"]', feuille); if (f) f.focus(); }
      }
      if (ouvrir) ouvrir.addEventListener('click', function () { ouverte(true); });
      if (voile) voile.addEventListener('click', function () { ouverte(false); });
      Cl.toutes('[data-cl="feuille-fermer"]').forEach(function (b) { b.addEventListener('click', function () { ouverte(false); }); });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && feuille && feuille.classList.contains('on')) ouverte(false);
      });
      document.addEventListener('click', function (e) {
        Cl.toutes('details.cl-tri[open]').forEach(function (d) { if (!d.contains(e.target)) d.removeAttribute('open'); });
      });
    }
  };

  /* Fiche : état du bouton d'ajout. Bloqué si la variante est épuisée, ou si le prénom manque (fiche brodée). */
  Cl.majBouton = function (fiche) {
    var form = document.getElementById(fiche.dataset.formulaire);
    if (!form) return;
    var dispo = form.dataset.dispo !== '0';
    var champ = Cl.une('[data-cl="prenom"]', fiche);
    var prenomOk = !champ || champ.value.trim() !== '';
    Cl.toutes('[data-cl="ajouter"]', fiche.parentNode).forEach(function (b) {
      b.disabled = !(dispo && prenomOk);
      if (!dispo) b.textContent = 'Épuisé';
      else if (champ) b.textContent = prenomOk ? (b.dataset.textePret || 'Ajouter au panier') : (b.dataset.texteVide || 'Ajouter au panier');
      else b.textContent = 'Ajouter au panier';
    });
  };

  /* Fiche : choix de variante par boutons radio, galerie, quantité. */
  Cl.variantes = {
    init: function () {
      Cl.toutes('[data-cl="fiche"]').forEach(function (fiche) {
        var form = document.getElementById(fiche.dataset.formulaire);
        var donnees = Cl.une('script[data-cl="variantes"]', fiche);
        if (!form || !donnees) return;
        var variantes = JSON.parse(donnees.textContent);
        var champId = Cl.une('[data-cl="variante-id"]', form);
        var rail = Cl.une('[data-cl="galerie"] .stage', fiche), compteur = Cl.une('[data-cl="galerie-compteur"]', fiche);
        if (rail && compteur) rail.addEventListener('scroll', function () {
          compteur.textContent = Math.round(rail.scrollLeft / rail.clientWidth) + 1;
        }, { passive: true });

        function choisies() {
          var sel = [];
          Cl.toutes('[data-cl-option]:checked', fiche).forEach(function (r) { sel[+r.dataset.clOption] = r.value; });
          return sel;
        }
        function trouver(sel) {
          return variantes.find(function (v) {
            return sel.every(function (val, i) { return val === undefined || v.options[i] === val; });
          });
        }
        function montrerMedia(id) {
          if (!id) return;
          var vue = Cl.une('[data-cl-media="' + id + '"]', fiche);
          if (!vue) return;
          Cl.toutes('.cl-vue', fiche).forEach(function (x) { x.classList.toggle('on', x === vue); });
          /* Sur téléphone la scène est un rail : on y fait glisser la photo de la variante. */
          if (rail && rail.scrollWidth > rail.clientWidth) rail.scrollTo({ left: vue.offsetLeft, behavior: 'smooth' });
          Cl.toutes('[data-cl-vignette]', fiche).forEach(function (b) {
            var on = b.dataset.clVignette === String(id);
            b.setAttribute('aria-pressed', on ? 'true' : 'false');
            b.style.borderColor = on ? '#3D6A8E' : 'transparent';
          });
        }
        function appliquer() {
          var sel = choisies();
          var v = trouver(sel);
          if (!v) { form.dataset.dispo = '0'; Cl.majBouton(fiche); return; }
          champId.value = v.id;
          form.dataset.dispo = v.dispo ? '1' : '0';
          Cl.toutes('[data-cl="prix"]').forEach(function (e) { e.textContent = v.prix; });
          Cl.toutes('[data-cl-option-libelle]', fiche).forEach(function (e) {
            var g = e.closest('[data-cl-option-groupe]');
            e.textContent = sel[+g.dataset.clOptionGroupe] || '';
          });
          Cl.toutes('[data-cl-prix-formule]', fiche).forEach(function (e) {
            var groupe = e.closest('[data-cl-option-groupe]');
            var i = +groupe.dataset.clOptionGroupe;
            var essai = sel.slice(); essai[i] = e.dataset.clPrixFormule;
            var w = trouver(essai);
            if (w) e.textContent = w.prix;
          });
          montrerMedia(v.media);
          var url = new URL(window.location.href);
          url.searchParams.set('variant', v.id);
          window.history.replaceState({}, '', url.toString());
          Cl.majBouton(fiche);
          fiche.dispatchEvent(new CustomEvent('cl:variante', { detail: v }));
        }

        Cl.toutes('[data-cl-option]', fiche).forEach(function (r) { r.addEventListener('change', appliquer); });
        Cl.toutes('[data-cl-vignette]', fiche).forEach(function (b) {
          b.addEventListener('click', function () { montrerMedia(b.dataset.clVignette); });
        });
        var qte = Cl.une('[data-cl="quantite"]', form);
        var moins = Cl.une('[data-cl="moins"]', form), plus = Cl.une('[data-cl="plus"]', form);
        if (qte && moins) moins.addEventListener('click', function () { qte.value = Math.max(1, (+qte.value || 1) - 1); });
        if (qte && plus) plus.addEventListener('click', function () { qte.value = Math.min(20, (+qte.value || 1) + 1); });
        var double = Cl.une('[data-cl="choisir-double"]');
        if (double) double.addEventListener('click', function () {
          var r = Cl.toutes('[data-cl-option]', fiche).find(function (x) { return /double/i.test(x.value); });
          if (r) { r.checked = true; appliquer(); r.closest('fieldset').scrollIntoView({ behavior: 'smooth', block: 'center' }); }
        });
        form.dataset.dispo = (trouver(choisies()) || { dispo: true }).dispo ? '1' : '0';
        Cl.majBouton(fiche);
      });
    }
  };

  /* Fiche brodée : prénom nettoyé (lettres, espace, trait d'union, apostrophe), aperçu en direct. */
  Cl.perso = {
    nettoyer: function (texte, max) {
      return texte.replace(/[^\p{L}\p{M} '’-]/gu, '').replace(/\s{2,}/g, ' ').slice(0, max);
    },
    init: function () {
      Cl.toutes('[data-cl-perso]').forEach(function (fiche) {
        var champ = Cl.une('[data-cl="prenom"]', fiche);
        var texte = Cl.une('[data-cl="apercu-texte"]', fiche);
        var svg = Cl.une('[data-cl="apercu-svg"] svg', fiche);
        var vide = texte ? texte.textContent : '';
        var max = champ ? (+champ.getAttribute('maxlength') || 12) : 12;
        var teinte = null;
        function traiter() {
          var propre = Cl.perso.nettoyer(champ.value, max);
          if (propre !== champ.value) champ.value = propre;
          if (texte) texte.textContent = propre.trim() || vide;
          Cl.majBouton(fiche);
        }
        if (champ) {
          /* Touches mortes (¨, ^ sur AZERTY Mac et Linux) : ne rien réécrire pendant la composition,
             sinon « Anaïs » devient « Anais ». On nettoie quand la lettre est composée. */
          champ.addEventListener('input', function (e) { if (!e.isComposing) traiter(); });
          champ.addEventListener('compositionend', traiter);
        }
        Cl.toutes('[data-cl-police]', fiche).forEach(function (r) {
          r.addEventListener('change', function () {
            if (!texte) return;
            texte.style.fontFamily = r.dataset.clPolice;
            texte.style.textTransform = r.dataset.clCasse;
          });
        });
        Cl.toutes('[data-cl-fil]', fiche).forEach(function (r) {
          r.addEventListener('change', function () {
            if (texte) texte.setAttribute('fill', r.dataset.clFil);
            var lib = Cl.une('[data-cl="fil-libelle"]', fiche);
            if (lib) lib.textContent = r.value;
          });
        });
        if (svg) {
          var corps = Cl.une('path', svg);
          teinte = corps ? corps.getAttribute('fill') : null;
        }
        fiche.addEventListener('cl:variante', function () {
          var coche = Cl.une('.cl-pastille input[data-cl-option]:checked', fiche);
          if (!coche || !svg || !teinte) return;
          var nouvelle = getComputedStyle(coche.parentNode).getPropertyValue('--teinte').trim();
          if (!nouvelle) return;
          Cl.toutes('[fill]', svg).forEach(function (e) {
            if (e.getAttribute('fill').toLowerCase() === teinte.toLowerCase()) e.setAttribute('fill', nouvelle);
          });
          teinte = nouvelle;
        });
      });
    }
  };

  /* Panier : SEUL propriétaire du submit des formulaires d'ajout (fiches, cartes, suggestion).
     Les ajouts sont mis en file : deux clics rapides sur le même doudou donnent une ligne en quantité 2. */
  Cl.panier = {
    file: Promise.resolve(),
    compte: function () {
      var c = Cl.une('[data-cl="panier-contenu"]');
      return c ? (+c.dataset.compte || 0) : 0;
    },
    erreur: function (texte) {
      Cl.toutes('[data-cl="panier-erreur"]').forEach(function (e) { e.textContent = texte || ''; });
    },
    majCompteur: function (n) {
      Cl.toutes('[data-cl="compteur"]').forEach(function (b) {
        b.textContent = n;
        b.style.display = n > 0 ? 'flex' : 'none';
        b.classList.remove('bump'); void b.offsetWidth; if (n > 0) b.classList.add('bump');
      });
      var lien = Cl.une('[data-cl="panier-ouvrir"]');
      if (lien) lien.setAttribute('aria-label', 'Panier, ' + n + ' article' + (n > 1 ? 's' : ''));
    },
    rafraichir: function () {
      return fetch(window.Shopify && Shopify.routes ? Shopify.routes.root + '?sections=cl-tiroir-panier' : '/?sections=cl-tiroir-panier', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (json) {
          var doc = new DOMParser().parseFromString(json['cl-tiroir-panier'], 'text/html');
          var neuf = Cl.une('[data-cl="panier-contenu"]', doc);
          var ancien = Cl.une('[data-cl="panier-contenu"]');
          if (neuf && ancien) ancien.replaceWith(neuf);
          var n = neuf ? (+neuf.dataset.compte || 0) : 0;
          Cl.panier.majCompteur(n);
          return n;
        });
    },
    ouvert: function (oui) {
      var t = Cl.une('[data-cl="panier-tiroir"]'), v = Cl.une('[data-cl="panier-voile"]');
      if (!t) return;
      var deja = t.classList.contains('on');
      t.classList.toggle('on', oui);
      if (v) v.classList.toggle('on', oui);
      document.body.classList.toggle('cl-fige', oui);
      if (oui && !deja) { var f = Cl.une('[data-cl="panier-fermer"]', t); if (f) f.focus(); }
      if (!oui) Cl.panier.erreur('');
    },
    ajouter: function (form) {
      var boutons = Cl.toutes('button[type="submit"]', form);
      if (form.id) boutons = boutons.concat(Cl.toutes('button[type="submit"][form="' + form.id + '"]'));
      boutons.forEach(function (b) { b.setAttribute('aria-busy', 'true'); });
      /* Prénom brodé : pas d'espace en trop (suggestion du clavier de téléphone « Léa »). */
      Array.prototype.forEach.call(form.elements, function (el) {
        if (el.name && el.name.indexOf('properties[') === 0 && typeof el.value === 'string' && el.type !== 'radio') el.value = el.value.trim();
      });
      var donnees = new FormData(form);
      var surPagePanier = !!Cl.une('[data-cl="page-panier"]');
      Cl.panier.file = Cl.panier.file.then(function () {
        var avant = Cl.panier.compte();
        return fetch('/cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: donnees })
          .then(function (r) {
            if (r.ok) return { ok: true };
            return r.json().catch(function () { return {}; }).then(function (j) {
              return { ok: false, texte: (r.status === 422 && j.description) ? j.description : 'Ce doudou n’a pas pu être ajouté. Réessayez dans un instant.' };
            });
          })
          .then(function (res) {
            if (surPagePanier) { window.location.reload(); return; }
            return Cl.panier.rafraichir().then(function (n) {
              if (res.ok || n > avant) Cl.panier.ouvert(true);
              if (!res.ok) { Cl.panier.ouvert(true); Cl.panier.erreur(res.texte); }
            });
          })
          .catch(function () {
            Cl.panier.ouvert(true);
            Cl.panier.erreur('Le panier ne répond pas. Réessayez dans un instant.');
          })
          .then(function () { boutons.forEach(function (b) { b.removeAttribute('aria-busy'); }); });
      });
      return Cl.panier.file;
    },
    changer: function (cle, quantite) {
      Cl.panier.file = Cl.panier.file.then(function () {
        return fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: cle, quantity: quantite }) })
          .then(function (r) {
            if (Cl.une('[data-cl="page-panier"]')) { window.location.reload(); return; }
            if (!r.ok) return r.json().catch(function () { return {}; }).then(function (j) {
              Cl.panier.erreur(j.description || 'La quantité n’a pas pu être modifiée.');
              return Cl.panier.rafraichir();
            });
            Cl.panier.erreur('');
            return Cl.panier.rafraichir();
          })
          .catch(function () { Cl.panier.erreur('Le panier ne répond pas. Réessayez dans un instant.'); });
      });
    },
    init: function () {
      document.addEventListener('submit', function (e) {
        var form = e.target;
        if (!form.matches || !form.matches('form[data-cl-ajout], form[action$="/cart/add"]')) return;
        e.preventDefault();
        Cl.panier.ajouter(form);
      });
      document.addEventListener('click', function (e) {
        var ouvrir = e.target.closest('[data-cl="panier-ouvrir"]');
        if (ouvrir && Cl.une('[data-cl="panier-tiroir"]')) {
          e.preventDefault();
          Cl.panier.rafraichir().then(function () { Cl.panier.ouvert(true); }, function () { window.location.href = ouvrir.href; });
          return;
        }
        if (e.target.closest('[data-cl="panier-fermer"], [data-cl="panier-voile"]')) { Cl.panier.ouvert(false); return; }
        var qte = e.target.closest('[data-cl-qte]');
        if (qte) {
          var ligne = qte.closest('[data-cl-ligne]');
          if (ligne) { qte.setAttribute('aria-busy', 'true'); Cl.panier.changer(ligne.dataset.clLigne, Math.max(0, +qte.dataset.clQte)); }
        }
      });
      document.addEventListener('keydown', function (e) {
        var t = Cl.une('[data-cl="panier-tiroir"]');
        if (e.key === 'Escape' && t && t.classList.contains('on')) Cl.panier.ouvert(false);
      });
    }
  };

  document.addEventListener('DOMContentLoaded', function () {
    Object.keys(Cl).forEach(function (nom) {
      if (Cl[nom] && typeof Cl[nom].init === 'function') Cl[nom].init();
    });
  });
})();
